export const topicElementIsVisibleOnPublicPage = (
  currentUser,
  topic,
  element,
) => (currentUser ? true : topic.config?.[`${element}_visible_public`]);
